<template>
  <div />
</template>

<script>
export default {
  props: {
    gaPixel: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.checkIfAnalyticsLoaded()
  },
  methods: {
    checkIfAnalyticsLoaded() {
      if (window.ga) {
        if (typeof window.ga !== 'undefined' && this.gaPixel !== '') {
          if (this.$store.state.pixels.gaPixels.indexOf(this.gaPixel) === -1) {
            eval(this.gaPixel)
            this.$store.dispatch('pixels/setGaPixel', this.gaPixel)
            window.ga('Extra.require', 'ecommerce')
            window.ga('Extra.send', 'pageview')
          }
        }
      } else {
        setTimeout(this.checkIfAnalyticsLoaded, 200)
      }
    }
  }
}
</script>